import { getStopApi } from '../../../services/StopApi/StopApi';

export const getOrganizationList = async ({
  commonParams,
  authorization,
  getCountyName,
  getSapInstitutionName,
}) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data;
    return {
      isLoading: false,
      total: response?.totalRows,
      data: json?.map((item, index) => ({
        ...item,
        id: index,
        orgId: item.orgId,
        orgKey: item.orgKey,
        city: item.city,
        countyId: getCountyName(item.countyId),
        isInstitution: item.isInstitution,
        institutionCode: item.institutionCode,
        institutionNumber: item.institutionNumber,
        isSap: item.isSap,
        sapCode: item.sapCode,
        sapNumber: item.sapNumber,
        sapInstitution: getSapInstitutionName(item.sapInstitution),
        stop: item.stop,
        cbp: item.cbp,
        parole: item.parole,
        other: item.other,
        westCare: item.westCare,
        inactive: item.inactive,
        vendor: item.vendor,
      })),
    };
  }).catch((e) => alert(e));
};
